
import { Box, ButtonBase, CircularProgress, createTheme, Grid, Stack, ThemeProvider, Typography } from '@mui/material';
import '../Card.css';
import { PieChart } from '@mui/x-charts';
import { useNavigate } from 'react-router-dom';
import { controlTowerMenuItems } from '../../../../routes/PrivateRoutes';
import './ShipmentCard.css'

const ShipmentCard = (props) => {

	const theme = createTheme({
		components: {
			MuiTypography: {
				defaultProps: {
					fontSize: 13,
				}
			},
			MuiButtonBase: {
				styleOverrides: {
					root: {
						flexDirection: 'column',
						width: '100%'
					}
				}
			}
		}
	})
	const navigate = useNavigate();

	const totalExceptionCount = props.exceptions?.totalCount || 0
	const totalStatesCount = props.states?.totalShipments || 0
	const totalShipmentCount = props.exceptions?.totalCount || 0


	const totalOnTimeCount = Number(props.exceptions?.data?.find(item => item.label === 'On Time' ||
		item.label === 'On Track')?.value || 0)
	const states = props.states?.data ?? []
	const exceptions = props.exceptions?.data ?? []
	const path = controlTowerMenuItems.find(item => item.label === props.title)?.path
	const valueFormatter = (item, total) =>
		`${total > 0
			? ((item.value * 100) / total)
				.toFixed(2)
				.replace(/\.00$/, "")
			: "0"}% (${item.value})`;
	const menuState = path.includes('supply') ? 'Supply' : path.includes('demand') ? 'Demand' : 'Inventory'
	const label = props.title === 'Inventory' ? 'Inventory List' : (controlTowerMenuItems.find(item => item.label === props.title)?.label)


	const detailedSeries = [
		{
			id: 'Exceptions',
			innerRadius: 40,
			outerRadius: 65,
			data: exceptions,
			highlightScope: {
				fade: 'global',
				highlight: 'item'
			},
			paddingAngle: 2,
			cx: states.length > 0 ? 85 : 130,
			cy: 70,
			arcLabelMinAngle: 0,
			valueFormatter: (item) => valueFormatter(item, totalExceptionCount - totalOnTimeCount)
		}
	]

	const statesTotal = states.length > 0 &&
		states.reduce((sum, curr) => sum + curr.value, 0)
	const statesSeries = [{
		id: 'States',
		innerRadius: 40,
		outerRadius: 65,
		data: states,
		highlightScope: {
			fade: 'global',
			highlight: 'item'
		},
		paddingAngle: 2,
		cx: 85,
		cy: 70,
		arcLabelMinAngle: 0,
		valueFormatter: (item) => valueFormatter(item, statesTotal)
	}]

	// const [searchFilter, setSearchFilter] = useState(path)

	const renderCardBody = () =>
		<>
			{/* <Grid container id='footer-header' size={ 12 } sx={ {
				padding: '8px 0 9px 0',
				justifyContent: 'center',
				// height: 'auto'
			} }> */}
			{/* <Typography fontWeight='bold' fontSize={ 16 }> </Typography> */}
			{/* </Grid> */}
			<Grid id='card-body' size={{ xs: 12 }} sx={{ width: '100%', minHeight: '370px', padding: 1, transition: 'min-height 0.2s' }}>
				<Grid id='chart-container' container sx={{
					width: "100%",
					display: "flex",
					justifyContent: "center",
					gap: 2,
					flexWrap: "wrap"
				}}
				>
					{/* <Grid id='exceptions-overview' size={{ xs: states.length > 0 ? 4 : 6 }}>
						
						<ButtonBase 
                            onClick={(event) => handleItemClick(event, { 
                                type: 'Overview', // Use Overview type
                                label: props.title === 'Inventory' ? 'On Track' : 'On Time',
                                value: totalOnTimeCount,
                                color: 'forestgreen'
                            })}
                            sx={{ width: '100%', flexDirection: 'column' }}
                        >
						<Grid id='exceptions-overview-label' container justifyContent='center' size={12}>
							<Grid size={12}>
								<Typography sx={{
									display: 'inline',
									fontWeight: 'bold',
									color: 'forestgreen'
								}}>
									{props.title === 'Inventory' ? 'On Track' : 'On Time'} :
								</Typography>
								<Typography sx={{
									display: 'inline',
									margin: 0,
									fontWeight: 'bold',
									marginLeft: '2px'
								}}>
									{valueFormatter({ value: totalOnTimeCount }, totalExceptionCount)}
								</Typography>
							</Grid>
							
							<Grid size={12}>
								<Typography sx={{
									display: 'inline',
									fontWeight: 'bold',
									color: 'red'
								}}>
									Exceptions:
								</Typography>
								<Typography sx={{
									display: 'inline',
									margin: 0,
									fontWeight: 'bold',
									marginLeft: '2px'
								}}>
									{totalExceptionCount - totalOnTimeCount} ({totalExceptionCount > 0 ?
										Math.round(((totalExceptionCount - totalOnTimeCount) / totalExceptionCount) * 100) : 0}%)
								</Typography>
							</Grid>
						</Grid>
						</ButtonBase>
					</Grid> */}
					<Grid id='exceptions-detailed' size={{ xs: states.length > 0 ? 4 : 6 }}>
						{renderPieChart('Exceptions', detailedSeries)}
						<Grid id='exceptions-detailed-label' container justifyContent='center' width='fit-content'>
							<Typography sx={{
								display: 'inline',
								color: 'red',
								fontWeight: 'bold'
							}}>Exceptions:

							</Typography>
							<Typography sx={{
								display: 'inline',
								fontWeight: 'bold',
								margin: 0,
								marginLeft: '2px'
							}}>
								{totalExceptionCount}
							</Typography>
							{renderLegends(exceptions, 'Exceptions')}
						</Grid>
					</Grid>
					{
						states.length > 0 &&
						<>
							<Grid id='states-overview' size={{ xs: 4 }}>
								{renderPieChart('States', statesSeries)}
								<Grid id='states-label' container size='auto' justifyContent='center' width='fit-content'>
									<Typography sx={{
										display: 'inline',
										color: 'red',
										fontWeight: 'bold',
									}}>
										States:
									</Typography>
									<Typography sx={{
										display: 'inline',
										fontWeight: 'bold',
										margin: 0,
										marginLeft: '2px'
									}}>
										{totalStatesCount}
									</Typography>
									{renderLegends(states, 'States')}
								</Grid>
							</Grid>
						</>
					}
				</Grid>
			</Grid>
		</>

	const renderPieChart = (type, series) =>
		<PieChart
			aria-label={`${type}-chart`}
			sx={{
				justifySelf: 'center'
			}}
			series={series}
			height={150}
			slotProps={{
				legend: {
					hidden: true
				}
			}}
			className='custom-pie-chart'
			onItemClick={(event, i, item) => handleItemClick(event, { type, ...item })}
		/>



	const renderLegends = (data, label) => {
  // Prioritize "On Time" and "On Track"
  const prioritizedLegends = data.filter(item => item.label === 'On Time' || item.label === 'On Track');
  
  // Filter out "On Time" and "On Track" legends from the main list
  const otherLegends = data.filter(item => item.label !== 'On Time' && item.label !== 'On Track');
  
  // Combine prioritized legends with the remaining ones
  const sortedLegends = [...prioritizedLegends, ...otherLegends];

  return (
    <Grid id="legends" container spacing={1} padding={1}>
      {sortedLegends.length > 0 &&
        sortedLegends.map(item => (
          <Grid
            container
            size="auto"
            key={item.label}
            alignItems="center"
            wrap="nowrap"
            sx={{
              marginBottom: "4px",
              cursor: "pointer",          
              '&:hover': { opacity: 0.7 } 
            }}
            onClick={(event) => {
              handleItemClick(event, {
                type: label,      
                label: item.label,
                value: item.value,
                color: item.color
              });
            }}
          >
            {/* Color box */}
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: 0.5,
                bgcolor: item.color,
                marginRight: "6px"
              }}
            />

            {/* Label */}
            <Typography
              fontSize={12.5}
              fontWeight={500}
              sx={{
                whiteSpace: "nowrap",
                marginRight: "4px"
              }}
            >
              {item.label}
            </Typography>

            {/* Percentage */}
            <Typography
              fontSize={12.5}
              fontWeight={700}
              sx={{ whiteSpace: "nowrap" }}
            >
              {valueFormatter(
                item,
                label === 'Exceptions'
                  ? totalExceptionCount
                  : statesTotal
              )}
            </Typography>
          </Grid>
        ))
      }
    </Grid>
  );
};




	const handleItemClick = (event, item) => {
		event.preventDefault();
		event.stopPropagation();

		if (item.type === 'Default') {
			navigate(path, {
				state: { menu: menuState, label }
			})
			return;
		}
		const searchFilter = `${path}`;
		let category = "";
		let subCategory = "";
		const pathSegments = path.split("/");
		if (pathSegments[2] === "inventory") {
			category = pathSegments[2] || "";
			subCategory = "Shipment";
		} else {
			category = pathSegments[2] || "";
			subCategory = pathSegments[3] || "";
		}

		const uniqueStorageKey = `filters_${category}_${subCategory}`;
		const priorityKey = `priority_${category}_${subCategory}`;


		let mappedStates = [];
		let mappedExceptions = [];
		if (item.type === 'Exceptions') {
			mappedExceptions = [{ "isActive": true, "detailName": item?.label, "count": item?.value }];

			localStorage.setItem(priorityKey, 'Exceptions');
		} else if (item.type === 'States') {
			mappedStates = [{ "isActive": true, "detailName": item?.label, "count": item?.value }];
			localStorage.setItem(priorityKey, 'States');
		} else if (item.type === 'Default' || item.type === 'Overview') {
			if (item.label !== "Exceptions") {

				mappedExceptions = [{ "isActive": true, "detailName": item?.label, "count": item?.value }];
				localStorage.setItem(priorityKey, 'Exceptions');

			}

		}

		localStorage.setItem(
			uniqueStorageKey,
			JSON.stringify({ selectedExceptions: mappedExceptions, selectedStates: mappedStates })
		);
		if (category === "inventory") {
			localStorage.setItem(priorityKey, 'Exceptions');
		}

		navigate(searchFilter, {
			state: { menu: menuState, label }
		})
	}

	return (
		<ThemeProvider theme={theme}>
			<Grid id='card-container' container size={{ xs: 12 }} sx={{ padding: 0, width: '100%' }}>
				<Grid id='title' aria-label={props.title} size={{ xs: 12 }} className="shipmentCard__draggable">
					<Typography fontSize={16} style={{
						borderRadius: '8px 8px 0 0',
						padding: '5px',
						backgroundColor: 'black',
						color: 'white'
					}}>
						{props.title} &nbsp; {(props.title === 'Inventory' ? totalExceptionCount : totalShipmentCount) ? `(${props.title === 'Inventory' ? totalExceptionCount : totalShipmentCount})` : 0}
					</Typography>
				</Grid>
				<ButtonBase disabled={props.isLoading} onClick={(event) => handleItemClick(event, { type: 'Default' })}>
					{
						!props.isLoading && renderCardBody()
					}
				</ButtonBase>
			</Grid >
			{props.isLoading &&
				<Stack size={{ xs: 12 }} alignItems='center' justifyContent='center' height='100%'>
					<CircularProgress aria-label='spinner' color='black' />
				</Stack>
			}
		</ThemeProvider>
	)
}

export default ShipmentCard;
